import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bell } from 'lucide-react';
import { requestNotificationPermission } from '../../utils/pushNotifications';
import { useAlert } from '../../context/AlertContext';
import { supabase } from '../../supabase/config';

const CustomerPortalNotifications = ({
    filteredNotifications,
    customer,
    customerId,
    primaryColor,
    openNotification,
    readNotifications
}) => {
    const { t } = useTranslation();
    const { showAlert } = useAlert();

    return (
        <div style={{ padding: '0 1.5rem', paddingBottom: '2rem' }}>
            {(!customer?.notificationsEnabled || Notification.permission !== 'granted') && (
                <div className="card glass" style={{
                    marginBottom: '1.5rem',
                    background: `linear-gradient(135deg, ${primaryColor}10 0%, ${primaryColor}20 100%)`,
                    border: `1px dashed ${primaryColor}`,
                    textAlign: 'center',
                    padding: '1.5rem'
                }}>
                    <Bell size={32} style={{ color: primaryColor, marginBottom: '0.75rem', margin: '0 auto' }} />
                    <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: '0 0 0.5rem 0' }}>Anlık Bildirimleri Aç</h3>
                    <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)', margin: '0 0 1.25rem 0' }}>
                        Kampanyaları ve sürpriz hediyeleri kaçırmamak için bildirimlere izin verin.
                    </p>
                    <button
                        onClick={async () => {
                            const res = await requestNotificationPermission(customerId);
                            if (res?.success) {
                                await supabase.from('customers').update({ notifications_enabled: true }).eq('id', customerId);
                                showAlert("Bildirimler başarıyla açıldı!", "success");
                            } else {
                                showAlert("Hata: " + (res?.error === 'not_supported' ? 'Tarayıcı desteklemiyor veya güvenli bağlantı (HTTPS) gerekli.' : res?.error), "error");
                            }
                        }}
                        style={{ background: primaryColor, color: 'var(--text-on-primary)', padding: '12px 24px', borderRadius: '12px', fontSize: '0.875rem', fontWeight: 700, border: 'none', cursor: 'pointer' }}
                    >
                        Şimdi Aktif Et
                    </button>
                </div>
            )}

            {filteredNotifications.length === 0 ? (
                <div className="card" style={{ padding: '3rem', textAlign: 'center', opacity: 0.5 }}>
                    <Bell size={48} style={{ margin: '0 auto 1rem' }} />
                    <p style={{ margin: 0 }}>{t('portal.noNotifications')}</p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {filteredNotifications.map(notif => (
                        <div
                            key={notif.id}
                            className="card-premium"
                            onClick={() => openNotification(notif)}
                            style={{
                                padding: 0,
                                overflow: 'hidden',
                                cursor: 'pointer',
                                border: !readNotifications.includes(notif.id) ? `1px solid ${primaryColor}40` : '1px solid var(--border)',
                                position: 'relative'
                            }}
                        >
                            {!readNotifications.includes(notif.id) && (
                                <div style={{ position: 'absolute', top: 12, right: 12, width: 8, height: 8, background: primaryColor, borderRadius: '50%', zIndex: 10 }}></div>
                            )}
                            {notif.imageUrl && (
                                <div style={{ width: '100%', aspectRatio: '16/9', overflow: 'hidden' }}>
                                    <img src={notif.imageUrl} alt={notif.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                            )}
                            <div style={{ padding: '1.25rem' }}>
                                <h4 style={{ fontWeight: 800, margin: '0 0 0.25rem 0' }}>{notif.title}</h4>
                                <p style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', margin: 0 }}>
                                    {notif.body}
                                </p>
                                {notif.actionLabel && (
                                    <div style={{ marginTop: '0.75rem' }}>
                                        <span style={{ display: 'inline-block', padding: '6px 14px', background: primaryColor, color: 'var(--text-on-primary)', borderRadius: '8px', fontSize: '0.75rem', fontWeight: 700 }}>
                                            {notif.actionLabel}
                                        </span>
                                    </div>
                                )}
                                <div style={{ marginTop: '0.75rem', fontSize: '0.7rem', color: 'var(--text-muted)', fontWeight: 600 }}>
                                    {notif.createdAt ? (notif.createdAt.toDate ? notif.createdAt.toDate() : new Date(notif.createdAt)).toLocaleDateString('tr-TR') : ''}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomerPortalNotifications;
